module.exports = __webpack_public_path__ + "static/media/PillsImg2.dc223b86.jpg";